<template>
  <v-container class="fill-height pb-0" >
    <v-card class="e-cardLeccion-final e-elevation--4 e-border--radius fill-height">
      <v-card-title class="e-cardLeccion-final-title verde-azul pb-0 justify-center">
        <div class="e-cardLeccion-final-title-bg">
          <img src="../../../../assets/images/gramatica/Gato.gif" alt="Personaje leccion"/>
        </div>
        <img src="../../../../assets/images/gramatica/award.png" alt="Personaje leccion" class="e-cardLeccion-final-title-award"/>
      </v-card-title>
      <v-card-text class="e-cardLeccion-final-text px-5 align-center d-flex justify-end">
        <div class="pt-3">
          <p class="e-sub-sub-title-md mb-0">Felicitaciones completaste la Lección {{ leccion }}</p>
          <v-btn
          v-if="!grammaIsFull"
          class="mt-3 elevation-0"
          block
          round
          large
          router-link
          :to="`/gramatica/${id_unit}/${id_grammar}/gramaticaDash`"
          color="verde-azul white--text">
            CONTINUAR
          </v-btn>
          <v-btn
          v-if="grammaIsFull"
          class="mt-3 elevation-0"
          block
          round
          large
          router-link
          :to="`/unidad/detalle/${this.id_unit}`"
          color="verde-azul white--text">
            CONTINUAR
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'LeccionFinal',
  props: {
    leccion: {
      type: String,
      default: ''
    },
    id_unit: {
      type: String
    },
    id_grammar: {
      type: String
    },
    grammaIsFull: {
      type: Boolean,
      default: false
    }
  }
}
</script>
